module.exports = __webpack_public_path__ + "img/dameng.837fc5bb.svg";